module.exports = __webpack_public_path__ + "img/insta-bg.805ba301.png";